export const CT_PLAYER_TYPE = {
	RETAIL: 'retail',
	ONLINE: 'online'
}